import { render, staticRenderFns } from "./reportIMSSales.vue?vue&type=template&id=f561184c&scoped=true&"
import script from "./reportIMSSales.vue?vue&type=script&lang=js&"
export * from "./reportIMSSales.vue?vue&type=script&lang=js&"
import style0 from "./reportIMSSales.vue?vue&type=style&index=0&id=f561184c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f561184c",
  null
  
)

export default component.exports